<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

// Zustand für die Sichtbarkeit des Buttons
const isVisible = ref(false);

// Scroll-Schwellenwert in Pixeln, ab dem der Button angezeigt wird
const scrollThreshold = 300;

// Event-Handler für das Scroll-Event
const handleScroll = () => {
  isVisible.value = window.scrollY > scrollThreshold;
};

// Funktion, um zum Seitenanfang zu scrollen
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// Event-Listener beim Mounten hinzufügen
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  // Initial prüfen
  handleScroll();
});

// Event-Listener beim Unmounten entfernen
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
  <button 
    v-show="isVisible" 
    @click="scrollToTop" 
    class="scroll-to-top" 
    aria-label="Zurück nach oben"
    title="Zurück nach oben"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  </button>
</template>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 99;
  transition: all 0.3s ease;
  opacity: 0.8;
}

.scroll-to-top:hover {
  transform: translateY(-5px);
  opacity: 1;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
}

/* Irische Stil-Akzente */
.scroll-to-top::before {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scroll-to-top:hover::before {
  opacity: 0.5;
}

/* Für mobile Geräte kleiner machen und nach links verschieben */
@media (max-width: 768px) {
  .scroll-to-top {
    width: 2.5rem;
    height: 2.5rem;
    bottom: 1.5rem;
    right: 1.5rem;
  }
  
  .scroll-to-top svg {
    width: 20px;
    height: 20px;
  }
}
</style> 